module.exports = __webpack_public_path__ + "img/image94.810ad89c.png";